define( 'es6ish-class/lib/ES6ishClassError',['require','exports','module'],function( require, exports, module ){
	function ES6ishClassError( message, child, parent ){
		this.name = 'ES6ishClassError';
		Error.prototype.constructor.call( this, message );
		this.message = message + ' : ' + Object.prototype.toString.call( parent );
		this.child = child;
		this.parent = parent;
	};
	ES6ishClassError.prototype = Object.create( Error.prototype );
	return ES6ishClassError;
});

